import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Home.css";
import slider1 from "../../../img/slide01.png";
import triner from "../../../img/training01.jpg";
import HomeCource from "./HomeCource";
import Teachers from "./Teachers/Teachers";

const Home = () => {
  return (
    <>
      <section style={{ overflow: "hidden" }}>
        <div className="container-fluid home-section">
          <Container>
            <Row className="gx-5">
              <Col>
                <h1 className="hero-title1">Refreshing</h1>
                <h1 className="hero-title2">Body And Soul</h1>
                <p className="hero-paragraph">
                  Meet yourself where you are mindfulness balance, tadasana
                  intentional. Namaste inhales, exhale reach expand open
                  intentional Bikram intentional. Rinse deeper out of your
                  comfort zone bandha self-care hug.
                </p>
                <button className="btn-style-1">More Information</button>
              </Col>
              <Col>
                <img src={slider1} alt="slider img" className="img-fluid" />
              </Col>
            </Row>
          </Container>
        </div>
        <svg
          style={{ fill: "#DCE3E2", width: "145%" }}
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
        </svg>
      </section>

      <Container>
        <Row className="gx-4">
          <Col md='6' sm='12'>
            <img src={triner} alt=""  className="img-fluid"/>
          </Col>
          <Col>
            <h4 className="trainer-section-title1">Let's start</h4>
            <h3 className="trainer-section-title2">Come As You Are</h3>
            <p className="trainer-section-paragraph hero-paragraph">
              Inhale namaste mudra bandha goddess. Mudra rejuvenate ujjayi
              inhale kata Sana renew meditation in motion out of your comfort
              zone ground down paschimot tadasana. Breath of fire inhale hatha
              yoga, mindfulness engage.
            </p>
            <button className=" btn-style-2">Join Us</button>
          </Col>
        </Row>
      </Container>
      <HomeCource></HomeCource>
      <Teachers></Teachers>
    </>
  );
};

export default Home;
